import * as React from "react";
function SvgInfoRound(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                d="M2 12.176a10.04 10.04 0 002.965 7.012 9.709 9.709 0 007.05 2.814 10.173 10.173 0 007.092-3.044 9.836 9.836 0 002.892-7.13A9.817 9.817 0 0012.164 2h-.18A10.092 10.092 0 002 12.176zm11.21 4.672a1.211 1.211 0 11-2.421 0v-5.45a1.211 1.211 0 112.421 0v5.45zM11.973 5.921h.026a1.514 1.514 0 11.026 3.028h-.026a1.514 1.514 0 11-.024-3.028h-.002z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgInfoRound);
export default ForwardRef;
